import React from "react";
import { useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";
import { Card, Container } from "reactstrap";
import "./LcaCards.css"; // Import your custom CSS file
import "moment-timezone/builds/moment-timezone-with-data";
import { myOffers } from "../Data2";
import { fetchBWV, fetchUserDetails } from "../Data";
import CarouselComponent from "./BizzList";
import BwvBox from "./BwvBox";

const BwvCards = ({ currentVendors, setLoading, carouselData }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { bwvLoading } = useSelector((state) => state.lcAds);
  return (
    <Container>
      {currentVendors && currentVendors.length > 0 && (
        <>
          {currentVendors.map((ad, index) => (
            <div key={ad.Id}>
              <p className="mb-0" style={{ fontSize: "medium" }}>
                {ad?.FullName}
              </p>
              <BwvBox ad={ad} />
              {index === 2 && carouselData.row1.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row1} />
                </Card>
              )}
              {index === 5 && carouselData.row2.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row2} />
                </Card>
              )}
              {index === 8 && carouselData.row3.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row3} />
                </Card>
              )}
            </div>
          ))}
        </>
      )}
    </Container>
  );
};

export default BwvCards;
